"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGFNotStableQuoteCalculator = void 0;
const TradeAPILib_1 = require("TradeAPILib");
const react_1 = require("react");
const trade_utils_lib_1 = require("trade_utils_lib");
const useGFNotStableQuoteCalculator = (params) => {
    const { shouldPerformCalculation, exchangeOrder, curPrice, quoteCurPrice, profit: _profit, unRealizedProfit: _unRealizedProfit, totalProfitPercent: _totalProfitPercent, profitPercent: _profitPercent, unRealizedProfitPercent: _unRealizedProfitPercent, total_profit_percentage: _total_profit_percentage, grid_profit_percentage: _grid_profit_percentage, } = params;
    const innerOrder = TradeAPILib_1.TradeUtils.getInnerOrder(exchangeOrder);
    const isRunning = exchangeOrder.isRunning;
    // 通过服务端投u的时候，usdt_investment 才会有值
    const isUToQuoteOrder = !!innerOrder.invest_coin && innerOrder.invest_coin !== exchangeOrder.quote;
    const closeSellModel = innerOrder.close_sell_model;
    const isBonusOrder = innerOrder.investment_from === TradeAPILib_1.GridFuturesInvestmentFrom.FUTURE_GRID_BONUS;
    // 动态保证金
    const extra_margin = (0, react_1.useMemo)(() => {
        if (shouldPerformCalculation) {
            if (isRunning) {
                return new trade_utils_lib_1.SafeDecimal(quoteCurPrice).mul(new trade_utils_lib_1.SafeDecimal(innerOrder.extra_margin)).toString();
            }
            if (closeSellModel === TradeAPILib_1.BotOrderCloseModel.TO_QUOTE) {
                return new trade_utils_lib_1.SafeDecimal(innerOrder.closed_quote_price).mul(new trade_utils_lib_1.SafeDecimal(innerOrder.extra_margin)).toString();
            }
            else {
                return new trade_utils_lib_1.SafeDecimal(innerOrder.quote_sell_price).mul(new trade_utils_lib_1.SafeDecimal(innerOrder.extra_margin)).toString();
            }
        }
        return innerOrder.extra_margin;
    }, [
        closeSellModel,
        innerOrder.closed_quote_price,
        innerOrder.extra_margin,
        innerOrder.quote_sell_price,
        isRunning,
        quoteCurPrice,
        shouldPerformCalculation,
    ]);
    const totalCost = (0, react_1.useMemo)(() => {
        var _a;
        if (shouldPerformCalculation) {
            if (isBonusOrder) {
                const USDTInvest = new trade_utils_lib_1.SafeDecimal(innerOrder.usdt_investment);
                return USDTInvest.toNumber();
            }
            // 实际投资额=实际投资额(quote)*投资平均成本(quote/U)
            return new trade_utils_lib_1.SafeDecimal(innerOrder.totalCost).mul(new trade_utils_lib_1.SafeDecimal(innerOrder.openQuotePrice)).toNumber();
        }
        return (_a = innerOrder.totalCost) !== null && _a !== void 0 ? _a : 0;
    }, [innerOrder.openQuotePrice, innerOrder.totalCost, innerOrder.usdt_investment, isBonusOrder, shouldPerformCalculation]);
    // 总利润(U)=(账户总权益(quote)-动态保证金)*当前quote/U价格-实际投资额(u)
    const totalProfit = (0, react_1.useMemo)(() => {
        if (shouldPerformCalculation) {
            if (isRunning) {
                // 保证金余额
                const marginBalanceD = new trade_utils_lib_1.SafeDecimal(innerOrder.margin_balance);
                // 开仓均价
                const agvPriceD = new trade_utils_lib_1.SafeDecimal(innerOrder.position_open_price);
                // 动态保证金
                const extraMarginD = new trade_utils_lib_1.SafeDecimal(innerOrder.extra_margin);
                // 运行中的订单的未实现盈亏
                const pnl = new trade_utils_lib_1.SafeDecimal(curPrice).sub(agvPriceD).mul(new trade_utils_lib_1.SafeDecimal(innerOrder.position));
                return new trade_utils_lib_1.SafeDecimal(quoteCurPrice)
                    .mul(marginBalanceD.add(pnl).minus(extraMarginD))
                    .minus(new trade_utils_lib_1.SafeDecimal(totalCost))
                    .toNumber();
            }
            const bonus_back_usdt = innerOrder.investment_from === TradeAPILib_1.GridFuturesInvestmentFrom.FUTURE_GRID_BONUS
                ? new trade_utils_lib_1.SafeDecimal(innerOrder.bonus_back_usdt)
                : 0;
            /** 用u开单 closeSellModel 为 TO QUOTE 不需要转换 */
            if (closeSellModel === TradeAPILib_1.BotOrderCloseModel.TO_QUOTE) {
                return new trade_utils_lib_1.SafeDecimal(innerOrder.closed_quote_price)
                    .mul(new trade_utils_lib_1.SafeDecimal(innerOrder.unlock_quote_amount))
                    .add(bonus_back_usdt)
                    .minus(new trade_utils_lib_1.SafeDecimal(totalCost))
                    .minus(new trade_utils_lib_1.SafeDecimal(extra_margin))
                    .toNumber();
            }
            else {
                return new trade_utils_lib_1.SafeDecimal(innerOrder.quote_sell_price)
                    .mul(new trade_utils_lib_1.SafeDecimal(innerOrder.unlock_quote_amount))
                    .add(new trade_utils_lib_1.SafeDecimal(innerOrder.unlock_usdt_amount).add(bonus_back_usdt))
                    .minus(new trade_utils_lib_1.SafeDecimal(totalCost))
                    .minus(new trade_utils_lib_1.SafeDecimal(extra_margin))
                    .toNumber();
            }
        }
        return innerOrder.totalProfit;
    }, [
        closeSellModel,
        curPrice,
        extra_margin,
        innerOrder.bonus_back_usdt,
        innerOrder.closed_quote_price,
        innerOrder.extra_margin,
        innerOrder.investment_from,
        innerOrder.margin_balance,
        innerOrder.position,
        innerOrder.position_open_price,
        innerOrder.quote_sell_price,
        innerOrder.totalProfit,
        innerOrder.unlock_quote_amount,
        innerOrder.unlock_usdt_amount,
        isRunning,
        quoteCurPrice,
        shouldPerformCalculation,
        totalCost,
    ]);
    const totalProfitPercent = (0, react_1.useMemo)(() => {
        if (shouldPerformCalculation) {
            return new trade_utils_lib_1.SafeDecimal(totalProfit).div(new trade_utils_lib_1.SafeDecimal(totalCost)).mul(100).toNumber();
        }
        return _totalProfitPercent;
    }, [_totalProfitPercent, shouldPerformCalculation, totalCost, totalProfit]);
    // 当前网格利润(U)=当前网格利润(quote)*当前quote/U价格
    const profit = (0, react_1.useMemo)(() => {
        if (shouldPerformCalculation) {
            if (isRunning) {
                return new trade_utils_lib_1.SafeDecimal(_profit).mul(new trade_utils_lib_1.SafeDecimal(quoteCurPrice)).toNumber();
            }
            if (closeSellModel === TradeAPILib_1.BotOrderCloseModel.TO_QUOTE) {
                return new trade_utils_lib_1.SafeDecimal(_profit).mul(new trade_utils_lib_1.SafeDecimal(innerOrder.closed_quote_price)).toNumber();
            }
            else {
                return new trade_utils_lib_1.SafeDecimal(_profit).mul(new trade_utils_lib_1.SafeDecimal(innerOrder.quote_sell_price)).toNumber();
            }
        }
        return _profit;
    }, [
        _profit,
        closeSellModel,
        innerOrder.closed_quote_price,
        innerOrder.quote_sell_price,
        isRunning,
        quoteCurPrice,
        shouldPerformCalculation,
    ]);
    const profitPercent = (0, react_1.useMemo)(() => {
        if (shouldPerformCalculation) {
            return new trade_utils_lib_1.SafeDecimal(profit).div(new trade_utils_lib_1.SafeDecimal(totalCost)).mul(100).toNumber();
        }
        return _profitPercent;
    }, [_profitPercent, profit, shouldPerformCalculation, totalCost]);
    const unRealizedProfit = (0, react_1.useMemo)(() => {
        if (shouldPerformCalculation) {
            return new trade_utils_lib_1.SafeDecimal(totalProfit).minus(new trade_utils_lib_1.SafeDecimal(profit)).toNumber();
        }
        return _unRealizedProfit;
    }, [_unRealizedProfit, profit, shouldPerformCalculation, totalProfit]);
    const unRealizedProfitPercent = (0, react_1.useMemo)(() => {
        if (shouldPerformCalculation) {
            return new trade_utils_lib_1.SafeDecimal(unRealizedProfit).div(new trade_utils_lib_1.SafeDecimal(totalCost)).mul(100).toNumber();
        }
        return _unRealizedProfitPercent;
    }, [_unRealizedProfitPercent, shouldPerformCalculation, totalCost, unRealizedProfit]);
    const total_profit_percentage = (0, react_1.useMemo)(() => {
        if (shouldPerformCalculation) {
            const totalPInUSDT = new trade_utils_lib_1.SafeDecimal(totalProfit);
            const _profitWithdrawn = new trade_utils_lib_1.SafeDecimal(innerOrder.profitWithdrawn);
            if (isRunning) {
                return totalPInUSDT.add(new trade_utils_lib_1.SafeDecimal(quoteCurPrice).mul(_profitWithdrawn)).div(totalCost).mul(100).toNumber();
            }
            if (closeSellModel === TradeAPILib_1.BotOrderCloseModel.TO_QUOTE) {
                return totalPInUSDT
                    .add(new trade_utils_lib_1.SafeDecimal(innerOrder.closed_quote_price).mul(_profitWithdrawn))
                    .div(totalCost)
                    .mul(100)
                    .toNumber();
            }
            else {
                return totalPInUSDT
                    .add(new trade_utils_lib_1.SafeDecimal(innerOrder.quote_sell_price).mul(_profitWithdrawn))
                    .div(totalCost)
                    .mul(100)
                    .toNumber();
            }
        }
        return _total_profit_percentage;
    }, [
        _total_profit_percentage,
        closeSellModel,
        innerOrder.closed_quote_price,
        innerOrder.profitWithdrawn,
        innerOrder.quote_sell_price,
        isRunning,
        quoteCurPrice,
        shouldPerformCalculation,
        totalCost,
        totalProfit,
    ]);
    const grid_profit_percentage = (0, react_1.useMemo)(() => {
        if (shouldPerformCalculation) {
            const P = new trade_utils_lib_1.SafeDecimal(innerOrder.gridProfit).add(new trade_utils_lib_1.SafeDecimal(innerOrder.profitWithdrawn));
            if (isRunning) {
                return new trade_utils_lib_1.SafeDecimal(quoteCurPrice).mul(P).div(totalCost).mul(100).toNumber();
            }
            if (closeSellModel === TradeAPILib_1.BotOrderCloseModel.TO_QUOTE) {
                return new trade_utils_lib_1.SafeDecimal(innerOrder.closed_quote_price).mul(P).div(totalCost).mul(100).toNumber();
            }
            else {
                return new trade_utils_lib_1.SafeDecimal(innerOrder.quote_sell_price).mul(P).div(totalCost).mul(100).toNumber();
            }
        }
        return _grid_profit_percentage;
    }, [
        _grid_profit_percentage,
        closeSellModel,
        innerOrder.closed_quote_price,
        innerOrder.gridProfit,
        innerOrder.profitWithdrawn,
        innerOrder.quote_sell_price,
        isRunning,
        quoteCurPrice,
        shouldPerformCalculation,
        totalCost,
    ]);
    const profitWithdrawn = (0, react_1.useMemo)(() => {
        if (shouldPerformCalculation) {
            if (isRunning) {
                return new trade_utils_lib_1.SafeDecimal(quoteCurPrice).mul(new trade_utils_lib_1.SafeDecimal(innerOrder.profitWithdrawn)).toNumber();
            }
            if (closeSellModel === TradeAPILib_1.BotOrderCloseModel.TO_QUOTE) {
                return new trade_utils_lib_1.SafeDecimal(innerOrder.closed_quote_price).mul(new trade_utils_lib_1.SafeDecimal(innerOrder.profitWithdrawn)).toNumber();
            }
            else {
                return new trade_utils_lib_1.SafeDecimal(innerOrder.quote_sell_price).mul(new trade_utils_lib_1.SafeDecimal(innerOrder.profitWithdrawn)).toNumber();
            }
        }
        return Number(innerOrder.profitWithdrawn);
    }, [
        closeSellModel,
        innerOrder.closed_quote_price,
        innerOrder.profitWithdrawn,
        innerOrder.quote_sell_price,
        isRunning,
        quoteCurPrice,
        shouldPerformCalculation,
    ]);
    return {
        totalCost,
        totalProfit,
        profit,
        unRealizedProfit,
        totalProfitPercent,
        profitPercent,
        unRealizedProfitPercent,
        total_profit_percentage,
        grid_profit_percentage,
        extra_margin,
        profitWithdrawn: Number(profitWithdrawn),
    };
};
exports.useGFNotStableQuoteCalculator = useGFNotStableQuoteCalculator;
